import { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";

import MDTypography from "common/components/MD/MDTypography";


// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
import Footer from "layouts/components/Footer";
import HeaderForm from "layouts/components/HeaderForm";

//prop-types is a library for typechecking of props
// Data

import ExpoPartecipazioniService from "services/API/expo_partecipazioni/ExpoPartecipazioniService";

import { useFarFieraUIController } from "common/context/FarFieraContext";
import ExpoPartecipazioneMyDotazioniList from "./ExpoPartecipazioneMyDotazioniList";


function DotazioniVis() {

  const [ffcontroller] = useFarFieraUIController();
  const { manifestazione } = ffcontroller;
  const [part, setPart] = useState({ idPartecipazione: 0, dotazioni: [{ id_dotazione: 0, tipo_dotazione: '' }] });




  
  useEffect(() => {
    filtra();
  }, [manifestazione]);




  function filtra() {
    setPart({ idPartecipazione: 0, moduli_obbligatori: [{ id_modulo: 0, nome_modulo: '' }] });
    console.log("Cambiata pp->seleziono i dettagli :" + manifestazione);
    ExpoPartecipazioniService.seleziona_partecipazione(manifestazione)
      .then(response => {
        console.log(response.data);
        setPart({
          idPartecipazione: response.data.idPartecipazione,
       
          id_utente: response.data.id_utente,
          nome_pdf_contratto: response.data.nome_pdf_contratto,
        richieste:response.data.richieste,
      
        });

  

     
      })
      .catch(e => {
        console.log(e);

      });

  }

 




  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>

          <Grid item xs={12}>

            <Card>
              <HeaderForm titolo={"Le tue dotazioni per " + manifestazione} color="info" />

              {(part && part.idPartecipazione) &&
                <MDBox pt={3}>
                      {part.richieste.map((richiesta) => (
                 
                      <ExpoPartecipazioneMyDotazioniList richiesta={richiesta} filtra={filtra}></ExpoPartecipazioneMyDotazioniList>      
               
                      ))}
                      </MDBox>
              }


      
              {!part.idPartecipazione &&


                <MDBox style={{ height: "200px" }} textAlign='center'>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}>
                    Non sei abilitato ad accedere a questa area!
                  </MDTypography></MDBox>

              }

            </Card>


          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}



export default DotazioniVis;
